import React, { useState, useEffect } from "react";
import {
    useGetAssignedComplianceListQuery,
    useGetAdminComplianceListQuery,
    useAssignTemplateMutation,
} from "../../appRedux/api/complianceApi";
import { useGetPartnerListQuery } from "../../appRedux/api/adminPartnerApi";
import { getRole } from "../../helpers";
import { Form, Row, Col, Button, Card, Spin, message, Modal, Select } from "antd";
import './style.css'

const { Option } = Select;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

const AssignComplianceTemplateModal = ({ visible, onCancel, onSuccess }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [selectedPartnerId, setSelectedPartnerId] = useState("");

    // Use the RTK query hook with list parameter
    const { data: partnersList, isLoading: partnersLoading } = useGetPartnerListQuery({ list: true });
    const { data: adminComplianceList, isLoading: complianceLoading } =
        useGetAdminComplianceListQuery();
    const { data: assignedComplianceList, isLoading: assignedLoading } =
        useGetAssignedComplianceListQuery(selectedPartnerId, {
        skip: !selectedPartnerId,
        });
    const [assignTemplate] = useAssignTemplateMutation();

    const [isUserAdmin, setIsUserAdmin] = useState(false);
    const [data, setData] = useState([]);
    const [admincomplianceListData, setadmincomplianceListData] = useState([]);
    const [assignedComplianceData, SetassignedComplianceData] = useState([]);
    const [assignedPartnerComliance, setassignedPartnerCompliance] = useState([]);

    const [form] = Form.useForm();

    useEffect(() => {
        setIsUserAdmin(() => {
        return getRole() === "ADMIN";
        });
    }, []);

    useEffect(() => {
        if (partnersList?.results) {
        // Transform the API response to match the expected format
        let rowData = partnersList.results
            .filter(item => item.partner) // Ensure partner data exists
            .map(item => ({
            key: item.partner.partner_id, // Use partner_id from the nested partner object
            name: item.partner.company_name // Use company_name from the nested partner object
            }));
        setData(rowData);
        }
    }, [partnersList]);

    useEffect(() => {
        const prefilledTemplates = [];
        assignedComplianceData.map((value) =>
        prefilledTemplates.push(value.c_id),
        );
        setassignedPartnerCompliance(prefilledTemplates);
    }, [selectedPartnerId]);

    useEffect(() => {
        if (adminComplianceList) {
        let complianceData = adminComplianceList.length
            ? adminComplianceList.map((value) => ({
                c_id: value.template_id,
                t_name: value.template_name,
            }))
            : [];
        setadmincomplianceListData(complianceData);
        }
    }, [adminComplianceList]);

    const getFinalAssignedComplianceList = (assignedComplianceArray) => {
        let data = [];
        assignedComplianceArray.forEach((val) => {
        if (val.assign_templates && val.assign_templates.length > 0) {
            for (let i = 0; i < val.assign_templates.length; i++) {
            data.push({
                c_id: val.template_id,
                t_name: val.template_name,
            });
            }
        } else {
            data.push({
            c_id: val.template_id,
            t_name: val.template_name,
            });
        }
        });
        return data;
    };

    useEffect(() => {
        if (assignedComplianceList) {
        let complianceData = assignedComplianceList.partner_templates;
        let filteredcomplianceData = complianceData
            ? complianceData.assign_templates
            : [];
        const finalAssisgnedComplianceData = getFinalAssignedComplianceList(
            filteredcomplianceData,
        );

        SetassignedComplianceData(finalAssisgnedComplianceData);
        }
    }, [assignedComplianceList]);

    const onFinish = async (values) => {
        setIsSubmitting(true);
        try {
            const template_id_data = [];
            var ele;
            for (ele in values.compliance_letter) {
                template_id_data.push({
                    template_id: values.compliance_letter[ele],
                });
            }
            const submitData = {
                partner_id: values.partner_list,
                templates: template_id_data,
            };

            await assignTemplate(submitData).unwrap();
            onSuccess();
            handleCancel();
        } catch (err) {
            message.error(err.data?.message || 'Failed to assign template');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        setSelectedPartnerId("");
        onCancel();
    };

    const getAssignedCompliance = (value) => {
        setSelectedPartnerId(value);
    };

    const options_data = (data) => {
        return data.map((user) => ({ 
        value: user.key, 
        label: user.name 
        }));
    };

    useEffect(() => {
        if (assignedComplianceList && assignedComplianceList.partner_templates) {
        form.setFieldsValue({
            compliance_letter:
            assignedComplianceList.partner_templates.assign_templates.map(
                (val) => val.template_id,
            ),
        });
        } else if (selectedPartnerId && !assignedLoading) {
        form.setFieldsValue({
            compliance_letter: [],
        });
        }
    }, [assignedComplianceList, assignedLoading, form, selectedPartnerId]);

    useEffect(() => {
        if (!visible) {
        form.resetFields();
        setSelectedPartnerId("");
        }
    }, [visible, form]);

    return (
    <Modal
        title={null}
        visible={visible}
        onCancel={handleCancel}
        footer={null}
        width={500}
        centered
        destroyOnClose
        className="assign-template-modal"
        >
        <div className="assign-template-header">
            <h2>Assign Template</h2>
            {/* <span className="close-btn" onClick={handleCancel}>×</span> */}
        </div>

        <Spin spinning={isSubmitting}>
            <Form
            form={form}
            layout="vertical"
            name="add-template"
            onFinish={onFinish}
            scrollToFirstError
            >
            <Form.Item
                name="partner_list"
                label="Partner"
                rules={[{ required: true, message: 'Please select a partner' }]}
            >
                <Select
                    showSearch
                    onChange={getAssignedCompliance}
                    loading={partnersLoading}
                    filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                    }
                    options={options_data(data)}
                    placeholder="Partner name here"
                    notFoundContent={partnersLoading ? "Loading..." : "No partners found"}
                />
            </Form.Item>

            <Form.Item
                name="compliance_letter"
                label="Assign"
                rules={[{ required: true, message: 'Please select at least one template' }]}
            >
                <Select
                    mode="multiple"
                    allowClear
                    placeholder="Select assigned here"
                    showSearch={false}
                    open={undefined}
                    filterOption={false}
                    showArrow={true}
                    optionFilterProp={undefined}
                    dropdownRender={undefined}
                    onInputKeyDown={e => e.preventDefault()}
                    onSearch={undefined}
                    onBlur={undefined}
                    onFocus={undefined}
                    onKeyDown={e => e.preventDefault()}
                >
                    {admincomplianceListData.map((letter) => (
                        <Option key={letter.c_id}>{letter.t_name}</Option>
                    ))}
                </Select>
            </Form.Item>

            <div className="modal-footer-btns">
                <Button
                className="cancel-btn"
                onClick={handleCancel}
                disabled={isSubmitting}
                >
                Cancel
                </Button>
                <Button
                type="primary"
                htmlType="submit"
                loading={isSubmitting}
                className="submit-btn"
                >
                Submit
                </Button>
            </div>
            </Form>
        </Spin>
    </Modal>
    );
};

export default AssignComplianceTemplateModal;